import {
    getUserInfo,
    searchCommittees as search,
    getCommitteeExpertByID,
    updateCommitteeExperiseByID,
    getProjectInfo as projectInfo,
    getCommitteeExpertInfo,
} from '../../../services/um/umServiceURL'
import useAuthenStore from '../../../stores/authen/authenStore'
import useCallApi from '../../../utilities/axios'

const useCommittees = () => {
    const callApi = useCallApi()
    const authenStore = useAuthenStore()

    const getCommitteeByID = async (userID: number | string) => {
        const response = await callApi.axiosGet({
            url: `${getUserInfo}/${userID}`,
        })
        return response?.data
    }

    const searchCommittees = async (
        keyword: string | null,
        facultyID: number | null,
        expertiseID: number | null,
        startDate: string,
        endDate: string,
    ) => {
        const response = await callApi.axiosPost({
            url: search,
            params: {
                keyword,
                irb: Number(authenStore.profile.irb),
                facultyID,
                expertiseID,
                startDate,
                endDate,
            },
        })
        return response?.data
    }

    const getExpertiseInfo = async (committeeID: number) => {
        const response = await callApi.axiosGet({
            url: `${getCommitteeExpertByID}/${committeeID}`,
        })
        return response.data
    }

    const updateCommitteeExperise = async (
        committeeID: number | null,
        body: {
            faculty: { label: string; value: string }
            expertList: [{ label: string; value: string }]
            updatedUserID: number
        },
    ) => {
        const response = await callApi.axiosPut({
            url: `${updateCommitteeExperiseByID}/${committeeID}`,
            params: body,
        })
        return response.data
    }

    const getProjectInfo = async (committeeID: number, isInProgress: boolean, startDate: string, endDate: string) => {
        const response = await callApi.axiosPost({
            url: projectInfo,
            params: {
                committeeID,
                isInProgress: isInProgress ? true : null,
                isFinish: !isInProgress ? true : null,
                startDate,
                endDate,
            },
        })
        return response.data
    }

    const getExpertInfo = async (committeeID: number) => {
        const response = await callApi.axiosGet({
            url: `${getCommitteeExpertInfo}/${committeeID}`,
        })
        return response.data
    }

    return {
        getCommitteeByID,
        searchCommittees,
        getExpertiseInfo,
        updateCommitteeExperise,
        getProjectInfo,
        getExpertInfo,
    }
}

export default useCommittees
